<template>
  <footer>
    <div id="footer" class="">
      <div class="footer-top">
        <div class="container">
          <div class="row">
            <div v-if="footerAbout" class="col-lg-3 col-md-6 footer-info">
              <div class="logo">
                <h1>
                  <a href="/"><span> {{ footerAbout.title }}</span></a>
                </h1>
              </div>
              <p>
                {{ footerAbout.short_description }} ...<a
                  :href="`${baseUrl}about`"
                  >আরো দেখুন</a
                >
              </p>
            </div>

            <div class="col-lg-6 col-md-12 footer-links">
              <h4>গুরুত্বপূর্ণ লিঙ্ক</h4>
              <div class="row">
                <div class="col-lg-6">
                  <ul>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}about`">আমাদের সম্পর্কে</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}contact`">যোগাযোগ</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}privacy-policy`">গোপনীয়তা নীতি</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <router-link :to="{name: 'CaQuiz'}">কারেন্ট অ্যাফেয়ার্স কুইজ</router-link>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-6">
                  <ul>
                    <li v-for="(item, index) in homeSections" v-bind:key="index">
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}section/${item.id}`">{{ item.title }}</a>
                    </li>
                    <!-- <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}books/Bestsellers`">বেস্টসেলার</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}books/New Releases`"
                        >সদ্য প্রকাশিত</a
                      >
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 footer-contact">
              <h4>যোগাযোগ</h4>
              <div style="padding-top: 10px">
                <div v-html="`${contact[0].description}`"></div>
                Phone : {{ contact[0].short_description }}<br />
              </div>

              <div class="social-links mt-3">
                <span v-for="(item, key) in social" v-bind:key="key">
                  <a
                    :href="`${item.short_description}`"
                    :class="`${item.title}`"
                    target="_blank"
                    ><i :class="`fa fa-${item.title}`"></i
                  ></a>
                </span>
              </div>

              <!-- <div class="visit mt-3">
                <div>Today Visit : {{ today_visitor }}</div>
                <div>Total Visit : {{ total_visitor }}</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="copyright-row">
        <div class="row d-flex justify-content-center">
          <div class="copyright">
            Copyright © {{ new Date().getFullYear() }}
            <a href="https://professorsprokashon.com">Professor's Prokashon</a>. All Rights
            Reserved.
          </div>

          <!-- <div class="payment-icons">
            <img src="/assets/img/icons/bkash.svg" alt="" />
            <img src="/assets/img/icons/roket.svg" alt="" />
            <img src="/assets/img/icons/amex.svg" alt="" />
            <img src="/assets/img/icons/master.svg" alt="" />
            <img src="/assets/img/icons/visa.svg" alt="" />
            <img src="/assets/img/icons/dbbl.svg" alt="" />
          </div> -->
        </div>
      </div>
    </div>
    <a href="javascript:;" class="back-to-top"
      > <i class="fa fa-arrow-up"></i>
    </a>

    <!-- WhatsApp Chat Widget -->
    <div class="whatsapp-widget">
      <a
        href="https://wa.me/8801324254610?text=%E0%A6%B9%E0%A7%8D%E0%A6%AF%E0%A6%BE%E0%A6%B2%E0%A7%8B!%20%E0%A6%86%E0%A6%AE%E0%A6%BE%E0%A6%B0%20%E0%A6%B8%E0%A6%BE%E0%A6%B9%E0%A6%BE%E0%A6%AF%E0%A7%8D%E0%A6%AF%20%E0%A6%AA%E0%A7%8D%E0%A6%B0%E0%A6%AF%E0%A6%BC%E0%A7%8B%E0%A6%9C%E0%A6%A8%E0%A5%A4"
        target="_blank"
        rel="noopener noreferrer"
        class="whatsapp-button"
        @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false"
      >
        <i class="fa fa-whatsapp"></i>
        <span class="pulse-ring"></span>
      </a>
      <div v-show="showTooltip" class="whatsapp-tooltip">
        সাহায্য প্রয়োজন? আমাদের সাথে চ্যাট করুন!
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      today_visitor: "",
      total_visitor: "",
      footerAbout: null,
      homeSections: [],
      contact: [
        {
          description: "Loading...",
          title: "Loading...",
          custom_field: null,
        },
      ],
      social: [],
      showTooltip: false,
    };
  },
  methods: {
    getFooterAbout() {
      fetch(this.APIURL + "cms-resources/Footer-About")
        .then((response) => response.json())
        .then((json) => (this.footerAbout = json.data[0]));
    },
    getContact() {
      fetch(this.APIURL + "cms-resources/Contact-Us")
        .then((response) => response.json())
        .then((json) => (this.contact = json.data));
    },
    getSocial() {
      fetch(this.APIURL + "cms-resources/Social-Links")
        .then((response) => response.json())
        .then((json) => (this.social = json.data));
    },
    getVisitors() {
      fetch(this.APIURL + "visitor-resources/count")
        .then((response) => response.json())
        .then((json) => {
          (this.today_visitor = json.today_visitor),
            (this.total_visitor = json.total_visitor);
        });
    },
    postVisitors() {
      let formData = new FormData();
      formData.append("count", 1);

      fetch(this.APIURL + "visitor-resources/count", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((json) => console.log(json));
    },
    getHomeSections() {
      this.$http
        .get("home-sections-name")
        .then((response) => {
          this.homeSections = response.data;
          console.log(response.data);
        })
        .catch((e) => {
          this.homeSections = [];
        });
    },
  },
  mounted() {
    this.getFooterAbout();
    this.getContact();
    this.getSocial();
    this.getVisitors();
    this.postVisitors();
    this.getHomeSections();
  },
  updated() {
    $(".loader").fadeOut("slow");
  },
};
</script>

<style scoped>
/* WhatsApp Widget Styles */
.whatsapp-widget {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  pointer-events: all;
}

.whatsapp-button {
  position: relative;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #25d366 0%, #128C7E 100%);
  color: #FFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  text-decoration: none;
}

.whatsapp-button:hover {
  transform: scale(1.15);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
  color: #FFF;
  text-decoration: none;
}

/* Pulsing ring animation */
.pulse-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #25d366;
  border-radius: 50%;
  animation: pulse 1.5s ease-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

/* Tooltip */
.whatsapp-tooltip {
  position: absolute;
  bottom: 75px;
  right: 0;
  background: #fff;
  color: #333;
  padding: 10px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  animation: fadeIn 0.3s ease;
  min-width: 200px;
  text-align: center;
}

.whatsapp-tooltip::after {
  content: '';
  position: absolute;
  bottom: -5px;
  right: 20px;
  width: 10px;
  height: 10px;
  background: #fff;
  transform: rotate(45deg);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Mobile responsive */
@media screen and (max-width: 767px) {
  .whatsapp-widget {
    bottom: 30px;
    right: 10px;
  }
  .whatsapp-button {
    width: 50px;
    height: 50px;
    font-size: 26px;
  }
  .whatsapp-tooltip {
    font-size: 12px;
    padding: 8px 12px;
    bottom: 60px;
    min-width: 180px;
  }
}
</style>
